import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

// Components
import Signin from '../containers/Signin';
import ResetPassword from '../components/auth/ResetPassword';
import AppLayout from '../containers/AppLayout';
import SalesInvoicePrint from "../components/common/SalesInvoicePrint";

const CustomRoute = ({ component: Component, failRedirect, restricted, isLoggedIn, ...rest }) => {

    return (
        <Route {...rest} render={props => (
            (isLoggedIn && restricted) || (!isLoggedIn && !restricted) ? (
                <Component {...props} />
            ) : (
                <Redirect to={{
                    pathname: failRedirect,
                    state: { from: props.location }
                }} />
            )
        )}/>
    );
};

class Routes extends Component {

    render() {
        return (
            <Router>
                <Switch>
                    <CustomRoute
                        exact
                        path="/signin"
                        component={Signin}
                        failRedirect="/"
                        isLoggedIn={this.props.isLoggedIn}
                    />
                    <CustomRoute
                        exact
                        path="/print"
                        component={SalesInvoicePrint}
                    />
                    <CustomRoute
                        path="/reset/:resetToken"
                        component={ResetPassword}
                        failRedirect="/"
                        isLoggedIn={this.props.isLoggedIn}
                    />
                    <CustomRoute
                        restricted
                        path="/"
                        component={AppLayout}
                        failRedirect="/signin"
                        isLoggedIn={this.props.isLoggedIn}
                    />
                </Switch>
            </Router>
        );
    }
}

function mapStateToProps(state) {

    return {
        isLoggedIn: state.auth.session.get('isLoggedIn')
    }
}

export default connect(mapStateToProps)(Routes);



// WEBPACK FOOTER //
// ./src/routes/Routes.js